import * as _ from 'lodash'
import {ProductGroupBO} from "./ProductGroupBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {
    WB_FinishedProductRelationshipRow,
    WB_ProductGroupRelationshipRow
} from "../PA.Core/PAdbSchemaRows";
import {DateUtils} from "../PA.Core/Basic/Dates";


export class ProductGroupBOValidations {


    static ValidateEmptyFields(aBO: ProductGroupBO): Promise<void> {


        return new Promise<void>((resolve, error) => {

            // Validate Product Group ID
            if (_.isEmpty(aBO.WB_ProductGroup.cif.PRODUCT_GROUP_ID) || _.isNull(aBO.WB_ProductGroup.cif.PRODUCT_GROUP_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: "Product Group ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }
            if (_.isEmpty(aBO.WB_ProductGroup.cif.PRODUCT_GROUP_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyName',
                        type: MessageType.Error,
                        title: "Product Group Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyName')
            }

            let bEmptyStartDate = false
            let bEmptyEndDate = false
            let bDateOrderingIncorrect = false
            let bHierarchyIncorrect = false

            _.forEach(_.filter(aBO.WB_ProductGroup.WB_ProductGroupChildProductRows, (x: WB_FinishedProductRelationshipRow) => x.isActive) , (aRow)=> {

                if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                    bEmptyStartDate = true
                }

                if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                    bEmptyEndDate = true
                }

                if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                    if(aRow.EffectiveEndDt < aRow.EffectiveStartDt){
                        bDateOrderingIncorrect = true
                    }
                }

                if ((aRow.cif.WB_PRDH_ID == 0) || _.isUndefined(aRow.cif.WB_PRDH_ID) || _.isNull(aRow.cif.WB_PRDH_ID)) {
                    bHierarchyIncorrect = true
                }
            })

            if(bDateOrderingIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildProductDateOrderingIncorrect',
                        type: MessageType.Error,
                        title: "Effective start date must be before the effective end date",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildProductDateOrderingIncorrect')

            }

            if (bEmptyStartDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildProductEmptyStartDate',
                        type: MessageType.Error,
                        title: "Effective Start Date cannot be empty in Child Products",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildProductEmptyStartDate')
            }

            if (bEmptyEndDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildProductEmptyEndDate',
                        type: MessageType.Error,
                        title: "Effective End Date cannot be empty in Child Products",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildProductEmptyEndDate')
            }

            if(bHierarchyIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildProductHierarchyIDIncorrect',
                        type: MessageType.Error,
                        title: "Hierarchy ID should not be null in Child Products",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildProductHierarchyIDIncorrect')

            }

            bEmptyStartDate = false
            bEmptyEndDate = false
            bDateOrderingIncorrect = false
            bHierarchyIncorrect = false

            _.forEach(_.filter(aBO.WB_ProductGroup.WB_ProductGroupRelationshipRows_Children, (x: WB_ProductGroupRelationshipRow) => x.isActive) , (aRow)=> {

                if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                    bEmptyStartDate = true
                }

                if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                    bEmptyEndDate = true
                }

                if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                    if(aRow.EffectiveEndDt < aRow.EffectiveStartDt){
                        bDateOrderingIncorrect = true
                    }
                }

                if ((aRow.cif.WB_PRDH_ID == 0) || _.isUndefined(aRow.cif.WB_PRDH_ID) || _.isNull(aRow.cif.WB_PRDH_ID)) {
                    bHierarchyIncorrect = true
                }


            })

            if(bDateOrderingIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildProductGrpDateOrderingIncorrect',
                        type: MessageType.Error,
                        title: "Effective start date must be before the effective end date",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildProductGrpDateOrderingIncorrect')

            }

            if (bEmptyStartDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildProductGrpEmptyStartDate',
                        type: MessageType.Error,
                        title: "Effective Start Date cannot be empty in Child Product Groups",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildProductGrpEmptyStartDate')
            }

            if (bEmptyEndDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildProductGrpEmptyEndDate',
                        type: MessageType.Error,
                        title: "Effective End Date cannot be empty in Child Product Groups",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildProductGrpEmptyEndDate')
            }

            if(bHierarchyIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildProductGrpHierarchyIDIncorrect',
                        type: MessageType.Error,
                        title: "Hierarchy ID should not be empty in Child Product Group",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildProductGrpHierarchyIDIncorrect')

            }

            bEmptyStartDate = false
            bEmptyEndDate = false
            bDateOrderingIncorrect = false
            bHierarchyIncorrect = false
            let bDuplicateParent = false
            let parentlength = _.filter(aBO.WB_ProductGroup.WB_ProductGroupRelationshipRows_Parent, (x: WB_ProductGroupRelationshipRow) => x.isActive)

                _.forEach(_.filter(aBO.WB_ProductGroup.WB_ProductGroupRelationshipRows_Parent, (x: WB_ProductGroupRelationshipRow) => x.isActive), (aRow) => {

                    if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                        bEmptyStartDate = true
                    }

                    if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                        bEmptyEndDate = true
                    }

                    if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                        if (aRow.EffectiveEndDt < aRow.EffectiveStartDt) {
                            bDateOrderingIncorrect = true
                        }
                    }

                    if ((aRow.cif.WB_PRDH_ID == 0) || _.isUndefined(aRow.cif.WB_PRDH_ID) || _.isNull(aRow.cif.WB_PRDH_ID)) {
                        bHierarchyIncorrect = true
                    }
                })

            if(bDuplicateParent){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'duplicateParent',
                        type: MessageType.Error,
                        title: "Multiple Parents are not allowed",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('duplicateParent')

            }
            if(bDateOrderingIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ParentDateOrderingIncorrect',
                        type: MessageType.Error,
                        title: "Effective start date must be before the effective end date",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ParentDateOrderingIncorrect')

            }

            if (bEmptyStartDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ParentEmptyStartDate',
                        type: MessageType.Error,
                        title: "Effective Start Date cannot be empty in Parent",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ParentEmptyStartDate')
            }

            if (bEmptyEndDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ParentEmptyEndDate',
                        type: MessageType.Error,
                        title: "Effective End Date cannot be empty in Parent",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ParentEmptyEndDate')
            }

            if(bHierarchyIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ParentHierarchyIDIncorrect',
                        type: MessageType.Error,
                        title: "Hierarchy ID should not be null in Parent",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ParentHierarchyIDIncorrect')

            }


            resolve()

        })

    }
}
